import { Link, useLocation } from "react-router-dom"
import { FileText, Clipboard, IndianRupee, Scan, Upload } from "lucide-react"
import { Button } from "../components/ui/button.tsx"

const sidebarItems = [
  { name: "Health Reports", href: "/my-reports", icon: FileText },
  { name: "Prescriptions", href: "/prescriptions", icon: Clipboard },
  { name: "Bills & Receipts", href: "/bills-receipts", icon: IndianRupee },
  { name: "Scanner", href: "/scanner", icon: Scan },
]

export default function ScannerPage() {
  const location = useLocation()

  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-gray-50">
      <aside className="w-full md:w-64 bg-white border-b md:border-r md:border-b-0">
        <nav className="p-4 space-y-2">
          {sidebarItems.map((item) => {
            const Icon = item.icon
            const isActive = location.pathname === item.href
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive
                    ? "bg-red-50 text-red-600"
                    : "text-gray-700 hover:bg-gray-100"
                }`}
              >
                <Icon className="w-5 h-5" />
                <span className="font-medium">{item.name}</span>
              </Link>
            )
          })}
        </nav>
      </aside>

      <main className="flex-1 p-4 md:p-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <Scan className="w-6 h-6 text-red-600" />
            <h1 className="text-2xl font-semibold">Scanner</h1>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-12">
            <div className="max-w-md mx-auto text-center">
              <Scan className="w-16 h-16 text-gray-400 mx-auto mb-4" />
              <h3 className="text-lg font-semibold mb-2">Scan Documents</h3>
              <p className="text-gray-600 mb-6">Upload and scan your medical documents</p>
              <Button className="gap-2">
                <Upload className="w-4 h-4" />
                Upload Document
              </Button>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}
